import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import useStyles from './styles';
export const BalanceStatus = _ref => {
  let status = _ref.status,
    hideText = _ref.hideText;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const getStatusClassName = () => {
    switch (status) {
      case 'Ok':
        return classes.balanceOk;
      case 'Due':
        return classes.balanceDue;
      case 'Critical':
      case 'Overdue':
        return classes.balanceCritical;
      default:
        return classes.balanceOk;
    }
  };
  const getStatusColor = () => {
    switch (status) {
      case 'Ok':
        return 'success';
      case 'Due':
        return 'warning';
      case 'Critical':
      case 'Overdue':
        return 'error';
      default:
        return 'success';
    }
  };
  const getStatusText = () => {
    switch (status) {
      case 'Ok':
        return t('general.ok');
      case 'Due':
        return t('general.due_approaching');
      case 'Critical':
      case 'Overdue':
        return t('general.overdue');
      default:
        return t('general.ok');
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.balanceStatus, " ").concat(getStatusClassName())
  }), !hideText && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: getStatusColor(),
    className: classes.statusText
  }, getStatusText()));
};